const PUSH = (state, data) => {
  state.excludes.push(data)
}

const SET_EXCLUDE = (state, exclude) => {
  state.exclude = exclude
}
const SET_EXCLUDES = (state, excludes) => {
  state.excludes = excludes
}

export default {
  PUSH,
  SET_EXCLUDE,
  SET_EXCLUDES
}
